import moment from 'moment';

export const HelperText = ({ product }) => {
  const { availability, preorder_release_date, preorder_message } = product;

  if (availability === 'disabled') {
    return 'Available in-store only. This product is not available for online purchase.';
  } else if (availability === 'preorder') {
    return `${preorder_message} ${preorder_release_date ? moment(preorder_release_date).format('MM/DD/YY') : ''}`;
  }
};
